import Vue from 'vue';
import Router from '#app#/router'
import Plyr from '@vendor/plyr/dist/plyr.polyfilled'

Vue.directive('parse-content', {
    inserted: function (el) {
        // Replace internal native a-link with Vue router-links
        el.addEventListener('click', event => handleLinkClicks(event));

        // Replace vimeo/youtube links with Plyr and initialize
        const expr = new RegExp("(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?", 'gi');
        el.innerHTML = el.innerHTML.replace(expr, `<div class="plyr" data-plyr-provider="$3" data-plyr-embed-id="$6"></div>`);
        el.innerHTML = el.innerHTML.replace(/provider="vimeo.com/g, 'provider="vimeo');
        el.innerHTML = el.innerHTML.replace(/provider="youtube.com/g, 'provider="youtube');
        const players = Array.from(el.querySelectorAll('.plyr')).map(p => new Plyr(p));
    }
})

function handleLinkClicks($event) {
    const { target } = $event
    // handle only links that occur inside the component and do not reference external resources
    if (target && target.matches("a:not([href^='http'])") && target.href) {
        // some sanity checks taken from vue-router:
        // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
        const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = $event
        // don't handle with control keys
        if (metaKey || altKey || ctrlKey || shiftKey) return
        // don't handle when preventDefault called
        if (defaultPrevented) return
        // don't handle right clicks
        if (button !== undefined && button !== 0) return
        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
            const linkTarget = target.getAttribute('target')
            if (/\b_blank\b/i.test(linkTarget)) return
        }

        const url = new URL(target.href)
        const to = url.pathname

        // don't handle media download links
        if (to.substring(0, 7) == '/media/') return

        // don't handle same page links/anchors
        if (window.location.pathname !== to && $event.preventDefault) {
            $event.preventDefault()
            Router.push(to)
        }
    } else if (target && target.matches("a") && target.href) {
        $event.preventDefault();

        const domain = window.location.protocol + '//' + window.location.hostname;

        if (target.href.indexOf(domain) !== -1) {
            // Internal absolute
            Router.push(target.href.replace(domain, ''));
            
        } else {
            // Real outbound link
            gaTracking.sendEvent('Outbound', 'click', target.href);
            window.open(target.href, target.target || '_self');
        }

    }
}

function parseVideo(html) {
    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551
    // - Also supports relative URLs:
    //   - //player.vimeo.com/video/25451551

    let match = html.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    console.log(match);

    if (RegExp.$3.indexOf('youtu') > -1) {
        var type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
        var type = 'vimeo';
    }

    return {
        url: match[0],
        type: type,
        id: RegExp.$6
    };
}


// WEBPACK FOOTER //
// ../default-js/js/directives/contentParser.js